export default __webpack_public_path__ + "resize-option.png";